const isBlobSource = (uri: string) => {
  return uri.startsWith('blob:')
}

export default isBlobSource
